<!--
  Title:部门管理
  Author:lixingtao
  DevelopmentTime:2021-03-30
  CompleteTime:2021-03-31
-->
<template>
  <div id="main">
    <el-row class="search-title common-table-top"
            style="margin-top: 20px; padding-right: 0">
      <el-col :span="4"
              class="table-title"
              style="text-align: left">
        <i class="el-icon-document"
           style="font-weight: bold"></i>
        <span>部门管理</span>
      </el-col>
      <el-col :span="20"
              class="text-align-right">
        <el-button type="primary"
                   v-show="btnType.add"
                   class="btn-link-large add-btn btn-right"
                   style="margin-top: 10px"
                   @click="openAddDialog">
          新建
        </el-button>
        <el-button type="primary"
                   class="btn-link-large add-btn btn-right"
                   style="margin-top: 10px"
                   @click="searchList">
          查询
        </el-button>
        <el-input v-model="searchName"
                  placeholder="请输入内容"></el-input>
      </el-col>
    </el-row>
    <TreeTable v-loading="loading"
               :data="data"
               :btnType="btnType"
               :columns="columns"
               @getRow="getRowValue"
               @changeStatus="changeStatus"
               @deleteInfo="confirmDelete"
               @openAddDialog="openAddDialog"
               @moveInfo="moveInfo" />
    <!-- <div class="pos-rel p-t-20">
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination totalPage"
          background
          @current-change="handleCurrentChangeTotal"
          :page-size="limit"
          :current-page="page"
          layout="total, prev, pager, next, jumper"
          :total="totalCountTotal"
        >
        </el-pagination>
      </div>
    </div> -->
    <!--添加部门弹窗-->
    <el-dialog class="cellDialog base-dialog"
               :title=" tap ? '添加部门':'修改部门'"
               :visible.sync="adddialog"
               width="520px">
      <el-form ref="addForm"
               :model="addForm"
               :rules="rules">
        <el-form-item label="部门名称:"
                      :label-width="addLabelWidth"
                      prop="name">
          <el-input class="stockInput"
                    type="text"
                    v-model="addForm.name"
                    auto-complete="off"
                    placeholder="输入部门名称"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="上级部门:"
                      :label-width="addLabelWidth"
                      prop="upLastBn">
          <el-select v-model="higherOfficeValue"
                     remote
                     filterable
                     :remote-method="(query)=>{getDealer(query,'自定义参数')}"
                     placeholder="请选择"
                     :disabled='!tap'
                     clearable>
            <el-option v-for="item in higherOffice"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包含业务区域:"
                      :label-width="addLabelWidth">
          <!-- <el-select v-model="value" placeholder="请选择" remote filterable :remote-method="(query)=>{getAreaList(query,'自定义参数')}" clearable> -->
          <el-select v-model="value"
                     placeholder="请选择"
                     clearable>
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="查看数据范围:"
                      :label-width="addLabelWidth"
                      prop="dataArea">
          <el-select v-model="dataViewRangeValue"
                     placeholder="请选择"
                     clearable>
            <el-option v-for="item in dataViewRange"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职能描述:"
                      :label-width="addLabelWidth">
          <el-input v-model="formRemark"
                    class="add-groups-input"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 4 }"
                    maxlength="200"
                    placeholder="请输入描述内容">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   @click="adddialog = false"
                   style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn"
                   style="margin-right: 32px"
                   type="primary"
                   @click="submitForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDepartment, useBanDepartment, addDepartment, editDepartment, deleteDepartment, moveUp, moveDown, rise, fall, getAreaList, getAreaDetail } from '@/api/customer.js'
import TreeTable from './tableTree/index' //表格树组件
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  components: {
    TreeTable,
  },
  data () {
    return {
      loading: false,
      searchName: '',
      limit: 10,
      adddialog: false,
      totalCountTotal: 1,
      page: 1,
      addLabelWidth: '96px',
      addForm: {
        name: '',
        remark: '',
        count: '',
        create_time: '',
        status: '',
        id: '',
      },
      value: '',
      options: [],
      higherOffice: [],
      higherOfficeValue: '',
      dataViewRange: [{ value: '0', label: '全部' }, { value: '1', label: '仅看本业务区域' }],
      dataViewRangeValue: '',
      columns: [
        {
          text: '部门名称',
          value: 'name',
          width: 300,
        },
        {
          text: '包含业务区域',
          value: 'businessArea',
        },
        {
          text: '数据查看范围',
          value: 'create_time',
        },
        {
          text: '是否启用',
          value: 'status',
        },
        {
          text: '操作',
          value: 'comment',
        },
      ],
      data: [],
      tap: false, //添加为true 修改为false
      formName: '',
      formRemark: '',
      rules: {
        name: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],
        dataArea: [{ required: true, message: '请输入查看区域范围', trigger: 'blur' }]
      },
      btnType: {
        'edit': false,
        'add': false,
        'del': false,
        'move': false
      }
    }
  },
  methods: {
    //添加模态框展示
    openAddDialog () {
      this.adddialog = true
      this.tap = true
      this.higherOfficeValue = ''
      this.dataViewRangeValue = ''
      this.addForm.name = ''
      this.formName = ''
      this.formRemark = ''
      this.value = ''
    },
    queryBtnList () {
      var itemId = getMenId(this.$route.path)
      butonsList({ systemCode: 'ZY_INTELLIQUOR', menuId: itemId })
              .then((res) => {
                if (res.data.code == '200') {
                  var btnList = this.btnType
                  for (let i = 0, k = res.data.result.length; i < k; i++) {
                    for (let m in btnList) {
                      if (res.data.result[i].perms.indexOf(m) != -1) {
                        this.btnType[m] = true
                      }
                    }
                  }
                }
              })
    },
    //修改启用状态
    switchChange (row) {
      row.status = row.status == 1 ? 0 : 1
    },
    //修改添加
    submitForm () {
      var object1 = new Object()
      this.formName = this.addForm.name
      if (this.formName === '' || this.formName === undefined || this.formName === null) {
        this.$message.error('部门名称不能为空')
        return
      }
      if (this.dataViewRangeValue === '' || this.dataViewRangeValue === undefined || this.dataViewRangeValue === null) {
        this.$message.error('查看数据范围不能为空')
        return
      }
      object1.name = this.formName
      object1.pid = this.higherOfficeValue === '' ? 0 : this.higherOfficeValue
      object1.remark = this.formRemark
      object1.dataViewRange = this.dataViewRangeValue
      object1.businessAreaId = this.value
      //添加
      if (this.tap) {
        addDepartment(object1).then((res) => {
          if (res.data.code === '200') {
            this.$message.success('添加成功')
            this.adddialog = false
            this.initList()
            this.getAreaList()
            this.getDealer()
          }else{
            this.$message.error(res.data.message)
          }
        })
      } else {
        //修改
        object1.id = this.addForm.id
        editDepartment(object1).then((res) => {
          if (res.data.code === '200') {
            this.$message.success('修改成功')
            this.adddialog = false
            this.initList()
            this.getAreaList()
            this.getDealer()
          }else{
            this.$message.error(res.data.message)
          }
        })
      }

    },
    //查询
    searchList () {
      this.initList()
    },
    //接受子组件传值
    getRowValue (row) {
      this.addForm = row
      getAreaDetail(row.id).then((res) => {
        if (res.data.code === '200') {
          var data = res.data.result
          this.adddialog = true
          this.tap = false
          var isc = this.isExist(data.pid)
          if (!isc) {
            this.higherOffice.push({ value: '' + data.pid, label: data.upName })
          }
          this.higherOfficeValue = data.pid === 0 ? '' : '' + data.pid
          this.dataViewRangeValue = '' + data.dataViewRange
          this.formName = data.name
          this.formRemark = data.remark
          this.value = data.businessAreaId === 0 ? '' : data.businessAreaId
        }
      })
    },
    isExist (id) {
      var isTrue = false
      for (let i = 0, k = this.higherOffice.length; i < k; i++) {
        if (this.higherOffice[i].value == id) {
          isTrue = true
        }
      }
      return isTrue
    },
    //删除确认
    confirmDelete (item) {
      this.$confirm('确认删除该部门?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDepartment(item.id).then((res) => {
          if (res.data.code == 200) {
            _g.toastMsg('success', '删除成功')
            this.getStructures()
            this.getAreaList()
            this.getDealer()
          } else {
            _g.toastMsg('error', res.data.message)
          }
        })
      }).catch((error) => {
      })
    },
    //跳转页码
    handleCurrentChangeTotal (val) {
    },
    //进行移动处理
    moveInfo (item) {
      //上移
      if (item.command == '上移') {
        moveUp(item.row.id).then((res) => {
          if (res.data.code === '200') {
            _g.toastMsg('success', res.data.message)
            this.initList()
          } else {
            _g.toastMsg('error', res.data.message)
          }
        })
      }
      //下移
      if (item.command == '下移') {
        moveDown(item.row.id).then((res) => {
          if (res.data.code === '200') {
            _g.toastMsg('success', res.data.message)
            this.initList()
          } else {
            _g.toastMsg('error', res.data.message)
          }
        })
      }
      //升序
      if (item.command == '升序') {
        rise(item.row.id).then((res) => {
          if (res.data.code === '200') {
            _g.toastMsg('success', res.data.message)
            this.initList()
          } else {
            _g.toastMsg('error', res.data.message)
          }
        })
      }
      //降序
      if (item.command == '降序') {
        fall(item.row.id).then((res) => {
          if (res.data.code === '200') {
            _g.toastMsg('success', res.data.message)
            this.initList()
          } else {
            _g.toastMsg('error', res.data.message)
          }
        })
      }
    },
    //改变信息状态
    changeStatus (row) {
      var status = row.status === 1 ? 0 : row.status === 0 ? 1 : ''
      useBanDepartment(row.id, row.status).then((res) => {
        if (res.data.code === '200') {
          _g.toastMsg('success', '修改成功')
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    //初始化部门列表
    initList () {
      this.loading = true
      getDepartment(this.searchName).then((res) => {
        var arrs = []
        this.loading = false
        if (res.data.code === '200') {
          var datas = res.data.result.id == -1 ? res.data.result.children : [res.data.result]
          datas.map((v, i) => {
            var obj = {
              id: v.id,
              name: v.text,
              dataViewRange: v.attributes.dataViewRange,
              businessArea: v.attributes.businessArea,
              remark: v.attributes.remark,
              parentId: v.parentId,
              create_time: '111',
              status: '', //第一层无启动禁用按钮
              comment: 'one',
              children: [],
              types: 'one' //判定是都为第一层
            }
            arrs.push(obj)
            if (v.children.length != 0) {
              this.recursionList(v.children, arrs[i].children)
            }
          })
          // var newArr = [{
          //   id:res.data.result.id,
          //   name:res.data.result.text,
          //   parentId: res.data.result.parentId,
          //   create_time:'111',
          //   status:'', //第一层无启动禁用按钮
          //   comment:'one',
          //   children:arrs,
          //   types:'one' //判定是都为第一层
          // }]
          this.data = arrs
        }
      })
    },
    //用递归将数据处理成树结构
    recursionList (data, el) {
      data.map((m, i) => {
        var obj = {
          id: m.id,
          name: m.text,
          create_time: '111',
          status: m.attributes.status,
          dataViewRange: m.attributes.dataViewRange,
          businessArea: m.attributes.businessArea,
          remark: m.attributes.remark,
          parentId: m.parentId,
          comment: 'button',
          children: []
        }
        el.push(obj)
        if (m.children.length != 0) {
          this.recursionList(m.children, el[i].children)
        }
      })
      return el
    },
    //动态查询上级部门
    getDealer (val) {
      getDepartment(val).then((res) => {
        this.higherOffice = []
        if (res.data.code === '200') {
          var datas = res.data.result
          if (datas.children.length == 0) {
            this.higherOffice.push({ value: datas.id, label: datas.text })
          } else {
            datas.children.map(v => {
              this.higherOffice.push({ value: v.id, label: v.text })
            })
          }
        }
      })
    },
    //初始化区域列表
    getAreaList (name) {
      getAreaList(name).then((res) => {
        if (res.data.code === '200') {
          var data = res.data.result
          var arrs = []
          data.map(v => {
            arrs.push({ label: v.name, value: v.id })
          })
          this.options = arrs
        }
      })
    }
  },
  created () {
    this.initList()
    this.getAreaList()
    this.getDealer()
    this.queryBtnList()
  },
  filters: {},
}
</script>

<style scoped>
  #main {
  }
  .text-align-right >>> .el-input {
    width: 20%;
    float: right;
  }

  .drag-tree-table {
    width: 96%;
    margin: 0 auto;
  }
  .drag-tree-table >>> .drag-tree-table-header {
    background: #fff;
  }
  .drag-tree-table >>> .colIndex4 .action-item {
    margin-right: 10px;
  }
  /deep/.lone {
    display: inline-block;
    margin: 0;
    margin-right: 10px;
    padding: 0;
  }
  /deep/ .lone li {
    list-style: none;
    display: none;
  }
</style>
